import { componentProvider } from 'js-component-framework/es';
import ToggleButton from '@/js/ToggleButton';

/**
 * Search drawer toggle.
 *
 * @param {HTMLFormElement} args.element The drawer element.
 */
function searchDrawer({ element }) {
  this.toggleButton = new ToggleButton(element, { loadOpen: element.hasAttribute('data-load-open') });
}

/**
 * Search results filter toggles.
 */
const searchDrawerConfig = {
  name: 'search-filter-section',
  component: searchDrawer,
};

// Load components.
componentProvider(searchDrawerConfig);
